// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import Alpine from "alpinejs";

Alpine.directive("faq", (element, {}, { cleanup, effect }) => {
  const dom = {
    cards: element.querySelectorAll<HTMLLIElement>(".c-faq-card"),
    list: ensureHTMLElement(element.querySelector(".c-faq__list")),
  };

  if (!dom.cards.length) return;

  let currentQuestion: HTMLElement | null = null;

  function openQuestion(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    currentQuestion = target === currentQuestion ? null : target;
    for (const card of dom.cards) {
      const isCurrent = card === currentQuestion;
      card.classList.toggle("c-faq-card--open", isCurrent);
    }
  }

  // Attach click event to questions
  for (const question of dom.cards) {
    question?.addEventListener("click", openQuestion);
  }

  cleanup(() => {
    for (const question of dom.cards) {
      question?.removeEventListener("click", openQuestion);
    }
  });
});
